import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * Recipe for the Specifications panel of the PDP details accordion.
 */
export default defineSlotRecipe({
    slots: [
        'module',
        'productData',
        'productScore',
        'divider',
        'compatibleProductsContainer',
        'characteristicsImageContainer',
        'characteristicsImage'
    ],
    base: {
        module: {
            justifyContent: 'center',
            flexDirection: {base: 'column-reverse', s: 'row'},
            px: 0,
            gap: {base: 'spacing-32', s: 0}
        },
        productData: {
            width: '100%',
            gap: 6,
            s: {flex: '1 1 0', minWidth: 0}
        },
        productScore: {
            gap: 'spacing-16'
        },
        divider: {
            borderColor: 'border.medium'
        },
        compatibleProductsContainer: {
            gap: 3,
            alignItems: 'flex-start'
        },
        characteristicsImageContainer: {
            width: '100%',
            justifyContent: 'center',
            alignItems: 'flex-start',
            s: {flex: '1 1 0', minWidth: 0}
        },
        characteristicsImage: {
            width: {base: '100%', s: '30.75rem'},
            maxWidth: '100%',
            height: 'auto'
        }
    }
})
